module.exports = __webpack_public_path__ + "static/img/b6234cbc.c10.af2322f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/b6234cbc.c10.jpg
// module id = gKnG
// module chunks = 2